export default __webpack_public_path__ + "static/media/contacrme.0aea53dd.svg";